import React, { useEffect, useRef, useState } from "react";
// @ts-ignore
import style from "./CustomSelect.module.css";
import { AltArrowRightIcon, CircleAlertIcon } from "@Models/icons";
import {
  DEFAULT_PHONE_COUNTRY_CODE,
  PHONE_COUNTRY_CODES,
  getPhoneCountry,
  getPhoneMaxLength,
  validatePhoneNumber,
} from "@Models/phoneCountryCodes";

// Hacer este componente reutilizable
const CustomSelect = ({
  setPhoneValues,
  phoneValues,
  handleInputChange,
  placeholder = "Ingrese su número de teléfono",
  isDisabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const dropdownRef = useRef(null);
  const [error, setError] = useState("");

  const currentCode =
    String(phoneValues.codeCountryPhone || "") || DEFAULT_PHONE_COUNTRY_CODE;
  const maxLength = getPhoneMaxLength(currentCode);

  useEffect(() => {
    setError(validatePhoneNumber(phoneValues.phoneNumber || "", currentCode) || "");
  }, [phoneValues.phoneNumber, currentCode]);

  const handleOutsideClick = (event) => {
    const dentroDelTrigger = selectRef.current?.contains(event.target);
    // El desplegable también cuenta como "adentro": si no, arrastrar su barra
    // de scroll (la lista de países no entra completa) lo cierra de golpe.
    const dentroDelDesplegable = dropdownRef.current?.contains(event.target);
    if (!dentroDelTrigger && !dentroDelDesplegable) {
      setIsOpen(false);
    }
  };

  const handleCodeChange = (e) => {
    e.preventDefault();
    const newCode = e.currentTarget.value;
    // Se recorta el número al largo máximo del nuevo país para no dejar
    // dígitos sobrantes de un código anterior más permisivo.
    const newMaxLength = getPhoneMaxLength(newCode);
    setPhoneValues({
      ...phoneValues,
      codeCountryPhone: newCode,
      phoneNumber: (phoneValues.phoneNumber || "").slice(0, newMaxLength),
    });
    setIsOpen(false);
  };

  const selectedCountryCode =
    getPhoneCountry(currentCode) ||
    getPhoneCountry(DEFAULT_PHONE_COUNTRY_CODE);

  // Emoji para todos los países (incluido Perú, que antes usaba peruFlag.svg):
  // el combo de edición solo puede mostrar texto, así que este es el único
  // formato que se ve igual en ambos formularios.
  const renderFlag = (country, className) => (
    <span className={className} role="img" aria-label={country?.name}>
      {country?.flag}
    </span>
  );

  const toggleSelect = (e) => {
    e.preventDefault();
    if (isDisabled) return;
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <>
      <div
        className={
          error
            ? `${style.phoneContainer} ${style.errorInput}`
            : style.phoneContainer
        }
        style={isDisabled ? { backgroundColor: "#f0f0f0" } : {}}
      >
        <button
          className={style.selectTrigger}
          onClick={toggleSelect}
          ref={selectRef}
          type="button"
          style={isDisabled ? { backgroundColor: "#f0f0f0" } : {}}
        >
          {renderFlag(selectedCountryCode, style.selectedOption)}
          <img
            src={AltArrowRightIcon}
            className={`${style.arrowIcon} ${
              isOpen ? style.activeArrowIcon : ""
            }`}
            alt={selectedCountryCode?.name}
          />
          <span className={style.codeCountryPhone}>
            {`+${selectedCountryCode?.code}`}
          </span>
        </button>
        <input
          className={style.phoneInput}
          type="text"
          placeholder={placeholder}
          value={phoneValues.phoneNumber}
          onChange={(e) => handleInputChange(e, phoneValues, setPhoneValues)}
          name="phoneNumber"
          maxLength={maxLength}
          style={isDisabled ? { backgroundColor: "#f0f0f0" } : {}}
          disabled={isDisabled}
        />
      </div>
      {error && (
        <div className={style.inputErrorContainer}>
          <img src={CircleAlertIcon} alt="warn" className={style.warnYou} />
          <p className={style.inputErrorMessage}>{error}</p>
        </div>
      )}
      {isOpen && (
        <div className={style.contenedorScroll} ref={dropdownRef}>
          <ul className={style.selectOptions}>
            {PHONE_COUNTRY_CODES.map((option) => (
              <li key={option.code}>
                <button
                  value={option.code}
                  onClick={handleCodeChange}
                  type="button"
                >
                  {renderFlag(option, style.optionFlag)}
                  {`+${option.code} ${option.name}`}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default CustomSelect;
